import { DetailPageSections } from "@app/ui/shared";
import { LlmKeyListByEnvironment } from "@app/ui/shared/llm-key/llm-key-list";
import { useParams } from "react-router";

export const EnvironmentLlmKeysPage = () => {
  const { id = "" } = useParams();

  return (
    <div className="mb-4">
      <DetailPageSections>
        <LlmKeyListByEnvironment envId={id} />
      </DetailPageSections>
    </div>
  );
};
